export class ElasticSearchResult {
  totalHits: number = 0;
  pageItemsCount: number = 0;
  data: any[] = [];
  index: string = '';
  aggregations: any;
}
